import React from 'react';
import styles from '../../styles.css';
import measureGroupBarStyles from '../MeasureGroupBar/styles.css';
import subCategoriesStyles from '../SubCategories/styles.css';
import { isAllChildrensSelected, isSearchedPhrase } from '../../utils';
import { lookupWordByUid } from '../../../../actions';
import { useTranslation } from 'react-i18next';

export default function ExternalMetricsBar({
	externals,
	selectedExternals,
	onExternalSelect,
	// subject,
	// isSimplifiedView,
	// selectedSubjects,
	// onSubjectSelect,
	// queryParams,
	nestedListsToShow,
	showNestedLists,
	// subjectCounters,
	// selectedGroupsOfSubjects,
	// onSelectAllSubjects,
	// addSelectedSubject,
	// removeSelectedSubject,
	// expandedMeasureBars,
	// setExpandedMeasureBars,
	// searchPhrase,
	// onSubjectChange,
}) {
	const { t } = useTranslation();
	return (
		<>
			<div className={styles.measureGroup}>
				<div className={`${styles.measureCollapse} ${styles.measureCollapseSimple}`}>
					<img className={styles.measureIcon} src={`/img/icons/external_data.svg`} alt={t('External Data')} />
					<h5 className={styles.externalName}>
						<a href="#">{t('External Data')}</a>
					</h5>
					<div className={measureGroupBarStyles.filler} />
					{!nestedListsToShow.includes('external') ? (
						<img
							className={styles.expandIcon}
							src="/img/icons/accordion_expand.svg"
							alt="Expand"
							width="24"
							height="24"
							onClick={() => {
								showNestedLists((displayedRows) => [...displayedRows, 'external']);
							}}
						/>
					) : (
						<img
							className={styles.expandIcon}
							src="/img/icons/accordion_contract.svg"
							alt="Contract"
							width="24"
							height="24"
							onClick={() => {
								showNestedLists((displayedRows) => displayedRows.filter((row) => row !== 'external'));
							}}
						/>
					)}
				</div>
			</div>

			<div
				className={`${subCategoriesStyles.measureExpand} ${!nestedListsToShow.includes('external') ? styles.hidden : ''}`}
			>
				<div>
					<p className={`${styles.appMenuIntro}`}>{t('external_data.navigation.info')}</p>
					<ul className={`${styles.externalList} ${subCategoriesStyles.appMenuList}`}>
						{externals.map((external, index) => (
							<li
								className={`${subCategoriesStyles.listItem} ${styles.externalItem}
							${selectedExternals.includes(external.id) ? ` ${styles.selectedExternal}` : ' '}
							`}
								key={`external_${index}`}
							>
								<a
									href={external.id}
									onClick={(e) => {
										e.preventDefault();
										onExternalSelect(external.id);
									}}
								>
									{external.name}
								</a>
							</li>
						))}
					</ul>
				</div>
			</div>
		</>
	);
}
